

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../../../Assets/logo.png';

const loadImage = (src) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = reject;
    });

const AppraisalPdfGenerator = async ({
    employeeDetails,
    tableData,
    comments = [],
    rating = [],
    pms_score_show,
    dynamicLogo
}) => {
    console.log(employeeDetails, "employeeDetails")
    const doc = new jsPDF();
    let y = 10;

    // Add logo
    const image = await loadImage(dynamicLogo);
    doc.addImage(image, 'PNG', 10, y, 60, 20);
    y += 30;

    // Title
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('PERFORMANCE OF THE YEAR 2024-2025', 10, y);
    y += 10;

    // Employee Details
    doc.setFontSize(11);
    doc.setFont(undefined, 'normal');

    for (let i = 0; i < employeeDetails?.length; i += 2) {
        const leftItem = employeeDetails[i];
        const rightItem = employeeDetails[i + 1];

        const leftText = `${leftItem.label}: ${leftItem.value}`;
        const leftWrapped = doc.splitTextToSize(leftText, 90);

        let rightWrapped = [];
        if (rightItem) {
            const rightText = `${rightItem.label}: ${rightItem.value}`;
            rightWrapped = doc.splitTextToSize(rightText, 90);
        }

        const lineHeight = 8;
        const rowHeight = Math.max(leftWrapped.length, rightWrapped.length) * lineHeight;

        doc.text(leftWrapped, 10, y);
        if (rightWrapped.length > 0) {
            doc.text(rightWrapped, 110, y);
        }

        y += rowHeight + 2;
    }

    y += 8;

    // KRA-KPI Sections
    tableData?.forEach((section, index) => {
        doc.setFontSize(13);
        doc.setFont(undefined, 'bold');
        doc.text(`${index + 1}. ${section?.kratitle}`, 10, y);
        y += 8;

        doc.setFontSize(12);
        doc.setFont(undefined, 'normal');
        doc.text(`KRA ID: ${section?.kraId}`, 10, y);
        doc.text(`Actual Weightage: ${section?.weight}`, 10, y + 8);
        doc.text(`Against Weightage: ${section?.TotalAchievement}`, 110, y + 8);
        y += 14;

        autoTable(doc, {
            startY: y,
            head: [['KRA KPI ID', 'Parameter', 'Weightage', 'Achievement', 'Against Weightage']],
            body: section?.kpis?.map((k) => [
                k.kpiId,
                k.parameter,
                k.weight,
                k.achievementPercentage,
                
                k.Achievement,
            ]),
            margin: { left: 10, right: 10 },
            columnStyles: {
                0: { cellWidth: 55 },
                1: { cellWidth: 55 },
                2: { cellWidth: 25 },
                3: { cellWidth: 30 },
                4: { cellWidth: 25 },
            },
            headStyles: {
                fillColor: '#287eb9',
                textColor: 255,
                fontStyle: 'bold',
                lineWidth: 0.2,
                lineColor: [0, 0, 0],
            },
            styles: {
                fontSize: 10,
                cellPadding: 3,
                lineWidth: 0.2,
                lineColor: [0, 0, 0],
            },
            alternateRowStyles: {
                fillColor: [245, 245, 245],
            },
        });

        y = doc.lastAutoTable.finalY + 10;
    });
    const commentRows = [];
    console.log(commentRows?.length, "commentRows")

    if (comments?.[0]?.asseseeComments) {
        commentRows.push(['Assesee Comment', comments[0].asseseeComments]);
    }

    // Manager/Reviewer Comments and Ratings
    if (pms_score_show) {


        // Ratings Table
        if (rating && rating.length > 0) {
            doc.setFont(undefined, 'bold');
            doc.text('Ratings', 10, y);
            y += 6;

            // First summary row as in the screenshot
            autoTable(doc, {
                head: [['Rating', rating?.[1]?.reviewer_rating, 'PMS Score', rating?.[0]?.pmsScore]],
                startY: y,
                styles: { fontSize: 10, cellPadding: 8 },
                headStyles: {
                    fillColor: [240, 240, 240], // light gray
                    textColor: 0,
                    fontStyle: 'bold',
                },
                columnStyles: {
                    0: { cellWidth: 40 },
                    1: { cellWidth: 100 },
                    2: { cellWidth: 40 },
                    3: { cellWidth: 30 },
                },
                didDrawPage: (data) => {
                    y = data.cursor.y + 10;
                },
            });

        } // Comments table
        // const commentRows = [];

        if (comments?.[1]?.asseseeComments) {
            commentRows.push(['Assessor Comment', comments[1].asseseeComments]);
        }

        if (comments?.[2]?.asseseeComments) {
            commentRows.push(['Reviewer Comment', comments[2].asseseeComments]);
        }

    }
    if (commentRows?.length > 0) {
        doc.setFont(undefined, 'bold');
        doc.text('Comments', 10, y);
        y += 6;

        autoTable(doc, {
            // head: [['Comment Type', 'Comment']],
            body: commentRows,
            startY: y,
            styles: { fontSize: 10, cellPadding: 5, valign: 'top' },
            headStyles: {
                fillColor: '#287eb9',
                textColor: 255,
                fontStyle: 'bold',
            },
            columnStyles: {
                0: { cellWidth: 50, lineWidth: 0.2, lineColor: [0, 0, 0] },
                1: { cellWidth: 130, lineWidth: 0.2, lineColor: [0, 0, 0] },

            },
            didDrawPage: (data) => {
                y = data.cursor.y + 10;
            },
        });





    }

    // Save PDF
    doc.save('Performance_Appraisal.pdf');
};

export default AppraisalPdfGenerator;
